var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_-_Circulo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1A1A1A;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_834",
    className: "st0",
    cx: 44.8,
    cy: 45,
    r: 43.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3090",
    className: "st1",
    d: "M62.2,61.2c0-0.2-0.3-0.3-0.3-0.3c-2.8-0.5-5.3-2.5-7.3-4.5c-2.8-2.9-5-6.2-6.9-9.7 c-0.3-0.7,0.1-0.8,0.1-0.8l0,0c5.3-2.1,6.4-7.5,6.4-8.9c0-6.8-6.6-8.8-12.3-8.8c-2.3,0-2.9,0.2-5.2,0.2c-2.7,0-4.3-0.2-4.7-0.2 c-0.4,0-0.6,0.3-0.6,0.7l0,0c0,1.6,3.8-1.1,3.8,4.4v22c0,5-3.6,3.7-3.6,4.8c0,0.4,0.5,0.6,0.8,0.6c1.3,0,2.9-0.2,4.9-0.2 c2.8,0,3.4,0.2,4.9,0.2c1.1,0,1.3-0.2,1.3-0.6c0-1.5-4.8,0.9-4.8-5.8V31.1c0-1.3,0.9-1.3,2.5-1.3c5.2,0,9.4,2.9,9.6,8.5 c0.1,4-3,7.2-7,7.3c-0.1,0-0.3,0-0.4,0c-0.6,0-1,0-1.6-0.1c-0.2,0-0.5,0.1-0.5,0.4c0,0.4,0.4,0.7,0.8,0.8c1.2,0.4,2.3,1.1,2.9,2.4 l0,0c2.9,5,6.5,12.7,14.6,12.7C62.5,61.7,62.2,61.5,62.2,61.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.628079d6a183250723287beea0e13357.svg";
export { ForwardRef as ReactComponent };